import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-flip-horizontal-icon',
  templateUrl: './design-flip-horizontal.component.html'
})
export class DesignFlipHorizontalComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
